<template>
    <div class="quest-wizard">
        <design-2021-apprentice-multistep-form-wizard-component
            :steps="formSteps"
            @update-current-page="updateCurrentPage"
            @submit-form="createProject">
            <template #step-1>
                <div class="step-1-name">
                    <design-2021-apprentice-multistep-wizard-project-name-step-component
                        v-model="formData.project_name">
                    </design-2021-apprentice-multistep-wizard-project-name-step-component>
                </div>
            </template>

            <template #step-2>
                <div class="step-2-settings">
                    <design-2021-apprentice-multistep-wizard-project-settings-step-component
                        v-model="formData.settings"
                        :courses-in="coursesIn"
                        :seasons-in="seasonsIn"
                        :editor-type-setting="editorTypeSetting">
                    </design-2021-apprentice-multistep-wizard-project-settings-step-component>
                </div>
            </template>

            <template #step-3>
                <div class="step-3-coordinators">
                    <design-2021-apprentice-multistep-wizard-project-coordinators-step-component
                        v-model="formData.coordinators"
                        :portfolio="false"
                        :teachers-in="teachersIn">
                    </design-2021-apprentice-multistep-wizard-project-coordinators-step-component>
                </div>
            </template>

            <template #step-4>
                <div class="step-4-options">
                    <design-2021-apprentice-multistep-wizard-project-options-step-component
                        v-model="formData.options"
                        :teachers-in="teachersIn">
                    </design-2021-apprentice-multistep-wizard-project-options-step-component>
                </div>
            </template>

            <template #step-5>
                <div class="step-4-overview">
                    <design-2021-apprentice-multistep-wizard-project-overview-step-component
                        :steps="formSteps"
                        :form-data="formData">
                    </design-2021-apprentice-multistep-wizard-project-overview-step-component>
                </div>
            </template>
        </design-2021-apprentice-multistep-form-wizard-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-apprentice-plus-type-wizard-component',
    props: {
        seasonsIn: {
            type: Array,
            required: true,
        },
        coursesIn: {
            type: Array,
            required: true,
        },
        teachersIn: {
            type: Array,
            required: true,
        },
        editorTypeSetting: {
            type: String,
            required: false,
            default: '',
        },
    },

    data() {
        return {
            formSteps: [
                {
                    step_number: 1,
                    title: this.$t('group.create.project_name'),
                },
                {
                    step_number: 2,
                    title: this.$t('group.create.settings'),
                },
                {
                    step_number: 3,
                    title: this.$t('group.create.administrators'),
                },
                {
                    step_number: 4,
                    title: this.$t('group.create.options'),
                },
                {
                    step_number: 5,
                    title: this.$t('group.create.overview'),
                },
            ],
            currentActivePage: 1,
            formData: {
                project_name: '',
                settings: {
                    type: 5,
                    season: '',
                    editor_type: '',
                    course: '',
                    banner: '',
                    start_date: '',
                    start_time: '00:00:00',
                    end_date: '',
                },
                coordinators: [],
                options: [
                    {
                        label: this.$t('group.create.calendar'),
                        key: 'agenda',
                        enabled: true,
                    },
                    {
                        label: this.$t('group.create.messages'),
                        key: 'messages',
                        enabled: true,
                    },
                    {
                        label: this.$t('group.create.files'),
                        key: 'files',
                        enabled: true,
                    },
                    {
                        label: this.$t('group.create.source_list'),
                        key: 'sourcelist',
                        enabled: true,
                    },
                    {
                        label: this.$t('group.create.logbook'),
                        key: 'logbook',
                        enabled: true,
                    },
                    {
                        label: this.$t('group.create.powerpoint'),
                        key: 'powerpoint',
                        enabled: true,
                    },
                    {
                        label: this.$t('group.create.plagiarism'),
                        key: 'plagiarism',
                        enabled: true,
                    },
                    {
                        label: this.$t('group.create.rating'),
                        key: 'rating',
                        enabled: false,
                    },
                    {
                        label: this.$t('group.create.roadmap'),
                        key: 'roadmap',
                        enabled: false,
                    },
                    {
                        label: this.$t('group.create.action_plan'),
                        key: 'actionplan',
                        enabled: false,
                    },
                ],
            },
        };
    },

    mounted() {
        const element = document.getElementsByClassName('page-title');
        if (element.length > 0) {
            element[0].childNodes[0].innerHTML = this.$t('group.create.new_plus_project');
        }
    },

    methods: {
        updateCurrentPage(pageIndex) {
            this.currentActivePage = pageIndex;
        },

        createProject() {
            const headers = { 'Content-Type': 'multipart/form-data' };
            let data = new FormData();
            data.append('name', this.formData.project_name);
            for (const [key, val] of Object.entries(this.formData.settings)) {
                switch (key) {
                    case 'start_date':
                    case 'end_date':
                        if (val !== '') {
                            data.append(`settings[${key}]`, val);
                        }
                        break;

                    case 'course':
                    case 'season':
                        if (Object.entries(val).length > 0) {
                            data.append(`settings[${key}]`, val.id);
                        }
                        break;

                    case 'editor_type':
                        if (Object.entries(val).length > 0) {
                            data.append(`settings[${key}]`, val.value);
                        }
                        break;

                    case 'type':
                        data.append(`settings[${key}]`, val);
                        break;

                    case 'banner':
                        if (val !== '' || val !== null) {
                            data.append(`settings[${key}]`, val);
                        }
                        break;
                }
            }

            for (const [key, val] of this.formData.options.entries()) {
                if (val.enabled) {
                    data.append(`options[${key}]`, val.key);
                }
            }

            let needle = 0;
            for (const [key, val] of this.formData.coordinators.entries()) {
                data.append(`coordinators[${key}][id]`, val.id);
                data.append(`coordinators[${key}][can_edit_permissions]`, val.can_edit_permissions ? 1 : 0);
                data.append(`coordinators[${key}][can_edit_portfolio]`, val.can_edit_portfolio ? 1 : 0);

                needle++;
            }

            this.alert.saving();
            this.axios.post(this.routes.group(), data, { headers: headers }).then(
                (response) => {
                    this.alert.success();
                    window.location.href = this.routes.groupShow(response.data.id);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
